export default class HttpError {
  message: string;
  stack?: string;
  statusCode: number;

  constructor({ message, statusCode }: { message: string; statusCode: number }) {
    this.message = message;
    this.statusCode = statusCode;
    this.stack = new Error().stack;
  }
}
